import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { TAG_UPI_IMMERSIVE } from '../../analytics/analytics.tagids.constants'
import { displayOutdoor, hideOutdoor } from '../../../store/ui/ui.actions'
import { selectIsOutdoorPrompted } from '../../../store/ui/ui.outdoor.selectors'
import TagActionButton from '../../genericComponents/TagActionButton'
import personArrowSurrounded from '../../genericComponents/assets/person-arrow-surrounded.svg'
import personFallingArrowSurrounded from '../../genericComponents/assets/person-falling-arrow-surrounded.svg'
import T from '../../i18n/T'
import { OUTDOOR_STATUS_PROMPT } from '../../outdoor/Utils'
import SVGIcon from '../../svg/SVGIcon'
import { useAction } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import s from './OutdoorButton.less'
import useTooltip from './useTooltip'

const OutdoorButton = () => {
  const statusIsPrompt = useSelector(selectIsOutdoorPrompted)
  const execDisplayOutdoor = useAction(displayOutdoor)
  const execHideOutdoor = useAction(hideOutdoor)
  const { tooltip, setTooltip, mouseListeners } = useTooltip({ ge: true })

  const onButtonClick = useEventCallback(() => {
    setTooltip(false)
    if (statusIsPrompt) {
      execHideOutdoor()
    } else {
      execDisplayOutdoor({ status: OUTDOOR_STATUS_PROMPT })
    }
  }, [statusIsPrompt, execHideOutdoor, execDisplayOutdoor])

  return (
    <div className={s.root}>
      <TagActionButton
        type={TAG_UPI_IMMERSIVE}
        className={classNames(s.button, statusIsPrompt && 'active')}
        onClick={onButtonClick}
        {...mouseListeners}
      >
        <SVGIcon url={personArrowSurrounded} />
        <SVGIcon url={personFallingArrowSurrounded} />
      </TagActionButton>
      <span className={classNames(s.buttonTooltip, tooltip && 'active')}>
        <T id={'map.tools.upi.tooltip'} />
      </span>
    </div>
  )
}

export default OutdoorButton
